import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const user = authService.user();

  // Check if user is authenticated and has Admin role
  if (user && user.role === 'Admin') {
    return true;
  }

  // If user is a Bidder, redirect to bid-sheets
  if (user && user.role === 'Bidder') {
    return router.createUrlTree(['/bid-sheets']);
  }

  // If not authenticated, redirect to login
  return router.createUrlTree(['/login']);
};
